/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FollowGate
 */
export interface FollowGate {
    /**
     * Must follow the given user ID to unlock
     * @type {number}
     * @memberof FollowGate
     */
    followUserId: number;
}

/**
 * Check if a given object implements the FollowGate interface.
 */
export function instanceOfFollowGate(value: object): value is FollowGate {
    let isInstance = true;
    isInstance = isInstance && "followUserId" in value && value["followUserId"] !== undefined;

    return isInstance;
}

export function FollowGateFromJSON(json: any): FollowGate {
    return FollowGateFromJSONTyped(json, false);
}

export function FollowGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'followUserId': json['follow_user_id'],
    };
}

export function FollowGateToJSON(value?: FollowGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'follow_user_id': value.followUserId,
    };
}

